import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Journalist from "./Journalist";

@Model()
class JournalistEnquiryRecipient extends ApplicationRecord {
  static jsonapiType = "journalist_enquiry_recipients";

  @BelongsTo() journalist: Journalist;

  @Attr() journalistEnquiryId: number;

  @Attr() journalistId: number;

  @Attr() journalistName: string;
}

export default JournalistEnquiryRecipient;
